let showToast = null;

export const setToastHandler = (fn) => {
  showToast = fn;
};

export const toast = {
  success: (msg, opts) => showToast?.(msg, "success", opts),
  error: (msg, opts) => showToast?.(msg, "error", opts),
  warning: (msg, opts) => showToast?.(msg, "warning", opts),
  info: (msg, opts) => showToast?.(msg, "info", opts),
};
